const phone = ''
const email = 'j-force.mall.eg@jumia.com'
const supportedLanguages = ['en', 'ar']
const personalInfo = {
  phoneNumberMask: '### #### ####'
}
const paymentMethods = {
  bankAccountMask: ''
}

export {
  // auxiliary objects
  phone,
  email,

  // languages
  supportedLanguages,

  // personal info
  personalInfo,

  // payment methods
  paymentMethods
}
